import { useContext } from "react";
import bannertop from "../../../../assets/bannertop.png"
import { AuthContext } from "../../../../contexts/AuthContext";
import notImage from "../../../../assets/sem-foto.png";
import { apiUrl } from "../../../../services/apiUrl";
import { api } from "../../../../services/api";

const Excel = require('exceljs');
const FileSaver = require('file-saver');


export default function useGerarXlsx() {
    const { user } = useContext(AuthContext);

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const gerarXlsx = async (newFilter, filter, enterprise, groupsSelected) => {
        let client = '';

        const visibleCredor = enterprise.length > 1;
        const rowFinal = visibleCredor ? "N" : "M";
        const idClient = groupsSelected.map(el => {
            return el.id
        })

        const { data: response } = await api({ method: "GET", url: "/source/analiticoPdf/" + idClient + "?&" + newFilter });
        let analytics = response.results ;
        analytics = analytics.map(el => {
            let val = ''
            if (el?.CNPJ.length > 11) {
                val = el?.CNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
            } else {
                val = el?.CNPJ.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            }
            el.CNPJ = val
            return {
                ...el
            }
        })

        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet("CREDOR", { views: [{ showGridLines: false }] });

        let images = [];
        const promises = []
        Object.keys(enterprise).map(async (element, index) => {
            const promise = new Promise(async (resolve) => {
                let blob = enterprise[index].logo_file ?  await fetch( `${apiUrl}/files/${enterprise[index].logo_file}`).then(r => r.blob()): notImage;
                let resultBase64 = enterprise[index].logo_file ? await toBase64(blob) : notImage;
                images.push(resultBase64)
                resolve(resultBase64)
            })
            promises.push(promise)
        })

        await Promise.all(promises)

        Object.keys(enterprise).forEach((element, index) => {
            if (index != 0) {
                client = client + `\n${index + 1} - ${enterprise[index].nome_fantasia}`
            } else {
                const label = enterprise.length > 1 ? `${index + 1} - ${enterprise[index].nome_fantasia}` : enterprise[index].nome_fantasia
                client = label
            }
            let logoCol;
            if (index > 2) {
                logoCol = 8 + index + 0.9;
            } else {
                logoCol = 8 + index;
            }

            let extension = enterprise[index].logo_file;
            if (extension) {
                extension = extension.split('.').pop();
                extension = extension.toLowerCase();
            }
            else {
                extension = "png";
            }

            //aqui precisa trocar para trazer os logos
            worksheet.addImage(workbook.addImage({
                base64: images[index],
                extension: extension,
            }), {
                tl: { col: logoCol, row: 2 },
                ext: { width: 80, height: 45 },
            });
        })

        const mediumBlackBorder = { style: 'medium', color: { argb: '000' } };
        const thickBlackBorder = { style: 'thick', color: { argb: '000' } };
        const thinBlackBorder = { style: 'thin', color: { argb: '000' } };
        const dottedBlackBorder = { style: 'dotted', color: { argb: '000' } };


        const logo = workbook.addImage({
            base64: bannertop,
            extension: 'png',
        });

        worksheet.addImage(logo, {
            tl: { col: 0, row: 1 },
            ext: { width: 233, height: 73 }
        });

        const arrData = analytics;
        // ${rowFinal}
        worksheet.mergeCells(`C2:G3`);
        worksheet.getCell('C2').value = "Relatório Estatístico - Analítico";
        worksheet.getCell("C2").font = { family: 4, size: 20, color: { argb: '002060' }, bold: true };
        worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.mergeCells(`C4:G4`);
        worksheet.getCell('C4').value = "Dados de Credor, Interno, Débito, Acordo e Finalização";
        worksheet.getCell("C4").font = { family: 4, color: { argb: '002060' }, bold: true };
        worksheet.getCell('C4').alignment = { vertical: 'middle', horizontal: 'center' };

        // dados do cliente e filtro

        worksheet.getCell('B8').value = "Credor:";
        worksheet.getCell('B8').alignment = { vertical: 'bottom', horizontal: 'Left' };

        worksheet.mergeCells("B9:B9");
        worksheet.getCell('B9').value = client.toUpperCase();
        worksheet.getCell("B9").font = { family: 4, color: { argb: 'ff3a3a' }, bold: true, };
        worksheet.getCell('B9').alignment = { vertical: 'Left', horizontal: 'left', wrapText: true };


        // filtros
        var n = 0;
        var linhaZ;

        Object.keys(filter).forEach((item, index) => {
            var linhaZ = String.fromCharCode(67 + n);
            if (!!filter[item]?.value?.length && (item !== "data_acordo" && item !== "data_finalizacao" && item !== "data_entrada" && item !== "vencimento" && item !== "id_estagio" && item !== "valor_original" && item !== "saldo")) {
                switch (item) {
                    case 'CNPJ':
                        worksheet.getCell(`A8`).value = 'CNPJ/CPF:';
                        worksheet.getCell(`A8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'contrato':
                        worksheet.getCell(`${linhaZ}8`).value = 'Contrato:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;


                    case 'titulo':
                        worksheet.getCell(`${linhaZ}8`).value = 'Título:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'id_acordo':
                        worksheet.getCell(`${linhaZ}8`).value = 'Id do Acordo:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'motivo':
                        worksheet.getCell(`${linhaZ}8`).value = 'Motivo:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;

                    default:
                        break;
                }

                let valueText = ''
                if (Array.isArray(filter[item]?.value)) {
                    filter[item]?.value?.map((value, index) => {
                        if (value && index != 0) {
                            valueText = `${valueText}, ${value.label}`
                        } else {
                            valueText = value.label
                        }

                    })
                } else {
                    valueText = filter[item]?.value
                }

                // if (item === "devedor") {
                //     worksheet.getCell(`B9`).value = `${worksheet.getCell(`B9`).value}, ${valueText}`;
                //     worksheet.getCell(`B9`).font = { family: 4, color: { argb: 'ff3a3a' }, bold: true };
                //     worksheet.getCell(`B9`).alignment = { vertical: 'Left', horizontal: 'Left' };

                // } else {
                //     worksheet.getCell(`${linhaZ}9`).value = valueText;
                //     worksheet.getCell(`${linhaZ}9`).font = { family: 4, color: { argb: 'ff3a3a' }, bold: true };
                //     worksheet.getCell(`${linhaZ}9`).alignment = { vertical: 'middle', horizontal: 'Left' };
                //     n = n + 1;
                // }
            } else if (filter[item]?.value.find(val => !!val)) {
                switch (item) {
                    case 'vencimento':
                        worksheet.getCell(`${linhaZ}8`).value = 'Vencimento:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'valor_original':
                        worksheet.getCell(`${linhaZ}8`).value = 'Valor Original:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'saldo':
                        worksheet.getCell(`${linhaZ}8`).value = 'Saldo:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'data_acordo':
                        worksheet.getCell(`${linhaZ}8`).value = 'Data do Acordo:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'data_finalizacao':
                        worksheet.getCell(`${linhaZ}8`).value = 'Data da Finalização:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'id_estagio':
                        worksheet.getCell(`${linhaZ}8`).value = 'Estágio:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;
                    case 'data_entrada':
                        worksheet.getCell(`${linhaZ}8`).value = 'Data de Entrada:';
                        worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                        break;

                    default:
                        break;
                }
                let valueText = ''

                if (Array.isArray(filter[item]?.value)) {
                    filter[item]?.value?.map((value, index) => {
                        if (item != "valor_original" && item != "saldo" && item != "id_estagio") {
                            value = new Date(value).toLocaleDateString()
                        }
                        if (item == "saldo" || item == 'valor_original') {
                            value = parseFloat(value).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        }
                        if (value && index != 0) {
                            valueText = `${valueText} - ${value}`
                        } else {
                            valueText = value
                        }

                    })
                } else {
                    valueText = filter[item]?.value
                }
                // worksheet.mergeCells("G9:H9");
                worksheet.getCell(`${linhaZ}9`).value = valueText;
                worksheet.getCell(`${linhaZ}9`).font = { family: 4, color: { argb: 'ff3a3a' }, bold: true };
                worksheet.getCell(`${linhaZ}9`).alignment = { vertical: 'middle', horizontal: 'Left' };
                worksheet.getCell(`${linhaZ}9`).numFmt = "0"
                n = n + 1;
            }


        });



        //Fim Filtros

        //Horizonta Lines
        worksheet.mergeCells(`A7:${rowFinal}7`);
        worksheet.getCell('A7').border = {
            top: thickBlackBorder,
            // bottom: mediumBlackBorder,
        };

        // worksheet.mergeCells(`A11:${rowFinal}11`);
        worksheet.getCell('A11').border = {
            // top: thickBlackBorder,
            bottom: mediumBlackBorder,
        };

        worksheet.mergeCells("A11:H11");
        // worksheet.mergeCells("J11:L11");

        worksheet.getRow(12).values = ['Credor', 'CNPJ/CPF', 'Cliente/Devedor', 'Contrato', 'Estágio', 'Motivo', 'Data de Entrada', 'Título', 'Vencimento', 'Valor Original', 'Saldo', 'Data do Acordo', 'Id do Acordo', 'Data da Finalização',];
        worksheet.getRow(12).height = 30;
        worksheet.getRow(12).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        worksheet.columns = [
            { key: 'credor', name: 'Credor', width: 12, },
            { key: 'CNPJ', name: 'CNPJ/CPF', width: (Math.max.apply(Math, analytics.map((a) => a?.CNPJ.length)) + 3), },
            { key: 'devedor', name: 'Cliente/Devedor', width: (Math.max.apply(Math, analytics.map((a) => a?.devedor.length)) + 3) },
            { key: 'contrato', name: 'Contrato', width: (Math.max.apply(Math, analytics.map((a) => a?.contrato.length)) + 3) },
            { key: 'id_estagio', name: 'Estágio', width: (Math.max.apply(Math, analytics.map((a) => a?.id_estagio.length)) + 3) },
            { key: 'motivo', name: 'Motivo', width: ((Math.max.apply(Math, analytics.map((a) => a?.motivo.length)) || 9) + 3) },
            { key: 'data_entrada', name: 'Data de Entrada', width: 12 },
            { key: 'titulo', name: 'Título', width: (Math.max.apply(Math, analytics.map((a) => a?.titulo.length)) + 3) },
            { key: 'vencimento', name: 'Vencimento', width: 18 },
            { key: 'valor_original', name: 'Valor Original', width: 20 },
            { key: 'saldo', name: 'Saldo', width: (Math.max.apply(Math, analytics.map((a) => a?.saldo.length)) + 9) },
            { key: 'data_acordo', name: 'Data do Acordo', width: 20 },
            { key: 'id_acordo', name: 'ID do acordo', width: 20 },
            { key: 'data_finalizacao', name: 'Data da Finalização', width: 20 },
        ];


        if (!visibleCredor) {
            worksheet.getRow(12).values = ['CNPJ/CPF', 'Cliente/Devedor', 'Contrato', 'Estágio', 'Motivo', 'Data de Entrada', 'Título', 'Vencimento', 'Valor Original', 'Saldo', 'Data do Acordo', 'Id do Acordo', 'Data da Finalização',];
            worksheet.columns = [
                { key: 'CNPJ', name: 'CNPJ/CPF', width: (Math.max.apply(Math, analytics.map((a) => a?.CNPJ.length)) + 3), },
                { key: 'devedor', name: 'Cliente/Devedor', width: (Math.max.apply(Math, analytics.map((a) => a?.devedor.length)) + 3) },
                { key: 'contrato', name: 'Contrato', width: (Math.max.apply(Math, analytics.map((a) => a?.contrato.length)) + 3) },
                { key: 'id_estagio', name: 'Estágio', width: (Math.max.apply(Math, analytics.map((a) => a?.id_estagio.length)) + 3) },
                { key: 'motivo', name: 'Motivo', width: ((Math.max.apply(Math, analytics.map((a) => a?.motivo.length)) || 9) + 3) },
                { key: 'data_entrada', name: 'Data de Entrada', width: 12 },
                { key: 'titulo', name: 'Título', width: (Math.max.apply(Math, analytics.map((a) => a?.titulo.length)) + 3) },
                { key: 'vencimento', name: 'Vencimento', width: 18 },
                { key: 'valor_original', name: 'Valor Original', width: 20 },
                { key: 'saldo', name: 'Saldo', width: (Math.max.apply(Math, analytics.map((a) => a?.saldo.length)) + 9) },
                { key: 'data_acordo', name: 'Data do Acordo', width: 20 },
                { key: 'id_acordo', name: 'ID do acordo', width: 20 },
                { key: 'data_finalizacao', name: 'Data da Finalização', width: 20 },
            ];
        }




        if (visibleCredor) {
            worksheet.getCell(`A12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };

            worksheet.getCell(`B12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`C12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`D12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`E12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`F12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`G12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`H12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`I11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`I12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`J11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`L11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`M11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`J12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`K12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`L12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`N11`).border = { bottom: mediumBlackBorder };


            worksheet.getCell("K10").value = 'TOTAL';
            // worksheet.getCell(`K10`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder, left: mediumBlackBorder, top: mediumBlackBorder };
            worksheet.getCell('K10').alignment = { vertical: 'bottom', horizontal: 'center' };
            worksheet.getCell('K11').value = (arrData.map(({ saldo }) => parseFloat(saldo))).reduce((partialSum, a) => partialSum + a, 0);
            worksheet.getCell(`K11`).numFmt = "R$###,###,###.00"
            worksheet.getCell('K11').alignment = { vertical: 'bottom', horizontal: 'right' };
            worksheet.getCell(`K11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`M12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`N12`).border = { bottom: mediumBlackBorder };
        } else {
            worksheet.getCell(`A12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`B12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`C12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`D12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`E12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`F12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`G12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`H12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`I11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`K11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`L11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`I12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`J12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`K12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`M11`).border = { bottom: mediumBlackBorder };

            worksheet.getCell("J10").value = 'TOTAL';
            // worksheet.getCell(`J10`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder, left: mediumBlackBorder, top: mediumBlackBorder };
            worksheet.getCell('J10').alignment = { vertical: 'bottom', horizontal: 'center' };
            worksheet.getCell('J11').value = (arrData.map(({ saldo }) => parseFloat(saldo))).reduce((partialSum, a) => partialSum + a, 0);
            worksheet.getCell(`J11`).border = { bottom: mediumBlackBorder };
            worksheet.getCell(`J11`).numFmt = "R$###,###,###.00"
            worksheet.getCell(`J11`).alignment = { vertical: 'bottom', horizontal: 'right' };
            worksheet.getCell(`M12`).border = { bottom: mediumBlackBorder };
        }

        worksheet.getCell(`L12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };


        /*Let's say you stored your data in an array called arrData. Let's say that your arrData looks like this */

        /* Now we use the keys we defined earlier to insert your data by iterating through arrData and calling worksheet.addRow()
        */
        var linha = 13;
        arrData.forEach(function (item, index) {
            const row = {
                credor: (enterprise.findIndex(el => el.cre_id == item.credor_id) + 1),
                CNPJ: item.CNPJ,
                devedor: item.devedor,
                contrato: item.contrato,
                motivo: item.motivo,
                id_estagio: item.id_estagio,
                data_entrada: item.data_entrada ? new Date(item.data_entrada).toLocaleDateString('pt-Br') : '',
                titulo: item.titulo,
                vencimento: item.vencimento ? new Date(item.vencimento).toLocaleDateString('pt-Br') : '',
                valor_original: parseFloat(item.valor_original),
                saldo: parseFloat(item.saldo),
                data_acordo: item.data_acordo ? new Date(item.data_acordo).toLocaleDateString('pt-Br') : '',
                id_acordo: item.id_acordo,
                data_finalizacao: item.data_finalizacao ? new Date(item.data_finalizacao).toLocaleDateString('pt-Br') : '',
            }
            if (!visibleCredor) {
                delete row.credor
            }
            worksheet.addRow(row);



            if (visibleCredor) {
                worksheet.getCell(`A${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`A${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`B${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`B${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`C${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
                worksheet.getCell(`D${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`D${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`E${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
                worksheet.getCell(`F${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`G${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`G${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`H${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`H${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`I${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder, };
                worksheet.getCell(`I${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`J${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
                worksheet.getCell(`K${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`J${linha}`).alignment = { vertical: 'bottom', horizontal: 'right' };
                worksheet.getCell(`K${linha}`).alignment = { vertical: 'bottom', horizontal: 'right' };
                worksheet.getCell(`L${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`L${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`M${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`M${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`N${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };

                worksheet.getCell(`M${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`N${linha}`).border = { bottom: dottedBlackBorder };
                worksheet.getCell(`J${linha}`).numFmt = "R$ ###,###,###.00"
                worksheet.getCell(`K${linha}`).numFmt = "R$ ###,###,###.00"
            } else {
                worksheet.getCell(`A${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`A${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`B${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
                worksheet.getCell(`C${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`C${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`D${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
                worksheet.getCell(`E${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`F${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`F${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`G${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`G${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`H${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder, };
                worksheet.getCell(`H${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`I${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
                worksheet.getCell(`J${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`I${linha}`).alignment = { vertical: 'bottom', horizontal: 'right' };
                worksheet.getCell(`J${linha}`).alignment = { vertical: 'bottom', horizontal: 'right' };
                worksheet.getCell(`K${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`K${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`L${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
                worksheet.getCell(`L${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };
                worksheet.getCell(`M${linha}`).alignment = { vertical: 'bottom', horizontal: 'center' };

                worksheet.getCell(`M${linha}`).border = { bottom: dottedBlackBorder };
                worksheet.getCell(`I${linha}`).numFmt = "R$ ###,###,###.00"
                worksheet.getCell(`J${linha}`).numFmt = "R$ ###,###,###.00"
            }


            linha++;
        })

        worksheet.mergeCells(`A${linha}:${rowFinal}${linha}`);
        worksheet.getCell(`A${linha}`).border = {
            bottom: thickBlackBorder,
            top: mediumBlackBorder,
        };

        linha += 2;
        worksheet.mergeCells(`A${linha}:${rowFinal}${linha}`);
        worksheet.getCell(`A${linha}`).value = `Data de extração ${new Date().toLocaleDateString('pt-BR')} | Extraído por: ${user?.email}`

        const buffer = await workbook.xlsx.writeBuffer();
        FileSaver.saveAs(new Blob([buffer]), "VERSUO - Relat_Estat - Analitico.xlsx");
    }

    return {
        gerarXlsx
    }
}